import { baseDocSerializer, docTypeHash } from "@megaron/resource";
import { Serializers, SerializerValue } from "@megaron/serializers";

export const priceListDocSerializer = Serializers.object({
  ...baseDocSerializer("price-list").fields,
  currency: Serializers.string.nullable(),
});

export type PriceListDoc = SerializerValue<typeof priceListDocSerializer>;

export const priceListDocTypeHash = docTypeHash(priceListDocSerializer);
